import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  getAuth,
  initializeAuth,
  type Auth,
} from 'firebase/auth';
import type { FirebaseApp } from 'firebase/app';

/**
 * Web counterpart to authPersistence.ts. Firebase Auth's browser persistence
 * (backed by localStorage) is the web equivalent of the native AsyncStorage
 * adapter — same "session survives a restart" guarantee, appropriate for a
 * browser instead of a device. Same initializeAuth-throws-on-fast-refresh
 * fallback to getAuth() as the native version.
 *
 * `popupRedirectResolver` must be set explicitly here — unlike getAuth(),
 * which wires up browserPopupRedirectResolver automatically, initializeAuth()
 * does not, and signInWithPopup/signInWithRedirect throw a plain
 * `auth/argument-error` with no other clue if it's missing (confirmed live
 * during Phase 1 verification — Google Sign-In failed with exactly that
 * error until this was added).
 */
export function createFirebaseAuth(app: FirebaseApp): Auth {
  try {
    return initializeAuth(app, {
      persistence: browserLocalPersistence,
      popupRedirectResolver: browserPopupRedirectResolver,
    });
  } catch {
    return getAuth(app);
  }
}
